import { getApiClientVigo } from './ApiClientVigo.js'

/**
 * Service für E-Mail-Bestätigung
 */

/**
 * Bestätigt eine E-Mail-Adresse mit dem übergebenen Token
 * @param {string} bestaetigungsToken - Das Bestätigungstoken aus der URL
 * @returns {Promise<{success: boolean, nachricht: string}>}
 */
export async function emailBestaetigen(bestaetigungsToken) {
    const client = getApiClientVigo()
    
    console.log('[BestaetigungService] Bestätige E-Mail mit Token:', bestaetigungsToken)
    
    try {
        const response = await client.get('/v2/Tarifrechner/emailbestaetigen', {
            params: {
                bestaetigungsToken: bestaetigungsToken
            },
            // Akzeptiere auch 400er-Responses, um Fehlermeldungen zu verarbeiten
            validateStatus: (status) => status >= 200 && status < 500
        })
        
        console.log('[BestaetigungService] Response Status:', response.status)
        console.log('[BestaetigungService] Response Data:', response.data)
        
        // Prüfe auf Erfolg
        if (response.status === 200 && response.data?.ok === true) {
            return {
                success: true,
                nachricht: response.data?.nachricht || 'E-Mail erfolgreich bestätigt.'
            }
        }
        
        // Fehlerfall - Nachricht aus Response extrahieren
        return {
            success: false,
            nachricht: response.data?.nachricht || 'Bestätigung fehlgeschlagen.'
        }
        
    } catch (error) {
        console.error('[BestaetigungService] Fehler:', error)
        return {
            success: false,
            nachricht: 'Ein Netzwerkfehler ist aufgetreten. Bitte versuchen Sie es später erneut.'
        }
    }
}
